import React from "react";
import { BiBed, BiBath } from "react-icons/bi";
import { LiaCompressArrowsAltSolid } from "react-icons/lia";
import { FiAnchor, FiShield } from "react-icons/fi";
import { MdElectricBolt, MdWater } from "react-icons/md";
import { GiBoatFishing } from "react-icons/gi";

export function getCategoryLabel(category) {
  switch (category) {
    case "house":
      return "Luxury House";
    case "boat-parking":
      return "Boat Slip";
    default:
      return "Property";
  }
}

export function getCategoryBadgeColor(category) {
  switch (category) {
    case "house":
      return "bg-slate-900/80 text-gold-300 ring-1 ring-gold-400/40 backdrop-blur-sm";
    case "boat-parking":
      return "bg-slate-900/80 text-gold-300 ring-1 ring-gold-400/40 backdrop-blur-sm";
    default:
      return "bg-slate-900/80 text-gold-300 ring-1 ring-gold-400/40 backdrop-blur-sm";
  }
}

export function renderCardFeatures(item) {
  if (item.category === "house") {
    const f = item.features || {};
    return (
      <>
        <li className="flex items-center me-4">
          <BiBed className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.bedrooms} Beds</span>
        </li>
        <li className="flex items-center me-4">
          <BiBath className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.bathrooms} Baths</span>
        </li>
        <li className="flex items-center me-4">
          <LiaCompressArrowsAltSolid className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.sqft?.toLocaleString()} sqft</span>
        </li>
      </>
    );
  }

  if (item.category === "boat-parking") {
    const f = item.features || {};
    return (
      <>
        <li className="flex items-center me-4">
          <FiAnchor className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.slipLength}ft Slip</span>
        </li>
        <li className="flex items-center me-4">
          <MdElectricBolt className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>Power: {f.powerHookup ? "Yes" : "No"}</span>
        </li>
        <li className="flex items-center me-4">
          <FiShield className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>Security: {f.security ? "24/7" : "No"}</span>
        </li>
      </>
    );
  }

  return null;
}

export function renderDetailFeatures(item) {
  if (item.category === "house") {
    const f = item.features || {};
    return (
      <>
        <div className="flex items-center">
          <BiBed className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.bedrooms} Bedrooms</span>
        </div>
        <div className="flex items-center">
          <BiBath className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.bathrooms} Bathrooms</span>
        </div>
        <div className="flex items-center">
          <LiaCompressArrowsAltSolid className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.sqft?.toLocaleString()} sqft</span>
        </div>
        {f.garage > 0 && (
          <div className="flex items-center">
            <GiBoatFishing className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
            <span>{f.garage}-Car Garage</span>
          </div>
        )}
        {f.waterfront && (
          <div className="flex items-center">
            <MdWater className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
            <span>Waterfront</span>
          </div>
        )}
      </>
    );
  }

  if (item.category === "boat-parking") {
    const f = item.features || {};
    return (
      <>
        <div className="flex items-center">
          <FiAnchor className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>{f.slipLength}ft Slip Length</span>
        </div>
        <div className="flex items-center">
          <GiBoatFishing className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>Covered: {f.covered ? "Yes" : "No"}</span>
        </div>
        <div className="flex items-center">
          <MdElectricBolt className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>Power Hookup: {f.powerHookup ? "Yes" : "No"}</span>
        </div>
        <div className="flex items-center">
          <MdWater className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>Water Access: {f.waterAccess ? "Yes" : "No"}</span>
        </div>
        <div className="flex items-center">
          <FiShield className="text-2xl me-2 text-slate-700 dark:text-slate-300" />
          <span>Security: {f.security ? "24/7" : "No"}</span>
        </div>
      </>
    );
  }

  return null;
}

export function CategoryBadge({ category }) {
  return (
    <span
      className={`px-4 py-1.5 text-[10px] font-display tracking-[0.25em] uppercase ${getCategoryBadgeColor(category)}`}
    >
      {getCategoryLabel(category)}
    </span>
  );
}
